import React, { useCallback } from 'react';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Skeleton from '@mui/material/Skeleton';

import { Exercise } from '../../types';

interface AvailableExercisesListItemProps {
  exercise?: Exercise;
  loading?: boolean;

  isExerciseSelected: (exercise: Exercise) => boolean;
  onAddExercise: (exercise: Exercise) => void;
  onRemoveExercise: (exercise: Exercise) => void;
}

const AvailableExercisesListItem = (props: AvailableExercisesListItemProps) => {
  const { exercise, loading = false, isExerciseSelected, onAddExercise, onRemoveExercise } = props;

  const handleSelectExercise = useCallback(() => {
    if (exercise) {
      if (isExerciseSelected(exercise)) {
        onRemoveExercise(exercise);
      } else {
        onAddExercise(exercise);
      }
    }
  }, [onAddExercise, onRemoveExercise, exercise, isExerciseSelected]);

  return (
    <ListItem dense button onClick={handleSelectExercise} disabled={loading}>
      <Checkbox checked={exercise && isExerciseSelected(exercise)} disableRipple disabled={loading} color="secondary" />
      <ListItemText primary={loading ? <Skeleton width={160} /> : exercise?.code} />
    </ListItem>
  );
};

export default AvailableExercisesListItem;
